import { ServerSentEventService } from '@/api/server-sent-event.service';
import type { CounterVideoWallHandoverEventDto } from '@carvia/ros-client-types';

export function mediaRotationHandoverEventsService(stationSlug?: string, authCode?: string) {
  if (!stationSlug) {
    return new ServerSentEventService<CounterVideoWallHandoverEventDto>(
      '/media-rotation/handover-events',
    );
  }

  const query = authCode ? `?${new URLSearchParams({ code: authCode })}` : '';
  return new ServerSentEventService<CounterVideoWallHandoverEventDto>(
    `/media-rotation/video-wall/${encodeURIComponent(stationSlug)}/handover-events${query}`,
  );
}
